export default __webpack_public_path__ + "static/media/filter.47c9024e.svg";